import { CUSTOMER_URLS, CUSTOMERINFO_URLS } from "../../apiConfig.js";
import { CUSTOMER_ERRORS } from "../../../common/constants/customerModule/customerConstants.js";
import apiClient from "../../apiInstance";

export const fetchCustomers = async () => {
    try {
        const response = await apiClient.get(CUSTOMER_URLS.FETCH_CUSTOMERS);
        return response.data;
    } catch (error) {
        console.error(CUSTOMER_ERRORS.FETCH_CUSTOMERS_ERROR, error);
        throw error;
    }
};

export const fetchCustomersInfo = async () => {
    try {
        const response = await apiClient.get(CUSTOMER_URLS.FETCH_CUSTOMERS_INFO);
        return response.data;
    } catch (error) {
        console.error(CUSTOMER_ERRORS.FETCH_CUSTOMERS_ERROR, error);
        throw error;
    }
};

export const addCustomer = async (customerData) => {
    try {
        const response = await apiClient.post(
            CUSTOMER_URLS.ADD_CUSTOMER,
            customerData
        );
        return response.data;
    } catch (error) {
        console.error(CUSTOMER_ERRORS.ADD_CUSTOMER_ERROR, error);
        throw error;
    }
};

export const updateCustomer = async (id, customerData) => {
    try {
        const response = await apiClient.put(
            `${CUSTOMER_URLS.UPDATE_CUSTOMER}/${id}`,
            customerData
        );
        return response.data;
    } catch (error) {
        console.error(CUSTOMER_ERRORS.UPDATE_CUSTOMER_ERROR, error);
        throw error;
    }
};

export const inEmailCustomer = async (id) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.SEND_IN_EMAIL_MESSAGE, {
            id
        });
        
        return response.data;
    } catch (error) {
        console.error(CUSTOMER_ERRORS.EMAIL_CUSTOMERS_ERROR, error);
        throw error;
    }
};

export const inTextCustomer = async (id) => {
    //console.log('Got to Frontend API');
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.SEND_IN_TEXT_MESSAGE, {
            id
        });
        return response.data;
    } catch (error) {
        console.error(CUSTOMER_ERRORS.TEXT_CUSTOMERS_ERROR, error);
        throw error;
    }
};
